import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { postLogNCrash } from '@/api/nhn';

function useTabletLog() {
  return useMutation<null, AxiosError, { body: string; traceId: string }>(
    (payload) => postLogNCrash(payload.body, payload.traceId, 'medical-tablet'),
    {
      retry: (failureCount, error) => {
        if (error.message === 'Network Error' && failureCount < 3) {
          return true;
        }
        return false;
      },
    },
  );
}

export default useTabletLog;
